<template>
  <div class="container mt-4" dir="rtl">
    
    <!-- 1. الفلاتر -->
    <div class="card shadow-sm mb-4 border-top-warning no-print">
      <div class="card-header bg-white py-3">
        <h5 class="mb-0 text-dark fw-bold">
          <i class="fas fa-microscope ms-2 text-warning"></i> فحص وتدقيق الدرجات (اكتشاف الأخطاء)
        </h5>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label fw-bold small">الفصل الدراسي</label>
            <select v-model="form.term" class="form-select">
              <option v-for="t in terms" :key="t.id" :value="t">{{ t.name }}</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label fw-bold small">المجموعة</label>
            <select v-model="form.group" class="form-select">
              <option v-for="g in groups" :key="g.id" :value="g.id">{{ g.group_name }}</option>
            </select>
          </div>
          <div class="col-md-4 d-flex align-items-end">
            <button @click="analyzeData" class="btn btn-warning w-100 fw-bold" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm ms-2"></span>
              <i class="fas fa-search ms-2"></i> بدء الفحص والتحليل
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. النتائج -->
    <div v-if="hasSearched">
      
      <!-- ملخص -->
      <div class="alert alert-light border shadow-sm d-flex justify-content-between align-items-center mb-4">
        <div>
          <h6 class="mb-0 fw-bold">نتائج الفحص الآلي:</h6>
          <span class="text-muted small">تم فحص {{ stats.total }} طالب</span>
        </div>
        <div v-if="students.length > 0">
          <span class="badge bg-danger fs-6 pulse-animation">
            <i class="fas fa-exclamation-circle ms-2"></i> تم اكتشاف {{ students.length }} حالة تستوجب المراجعة
          </span>
        </div>
        <div v-else class="text-success fw-bold">
          <i class="fas fa-check-circle ms-2"></i> البيانات سليمة ومنطقية 100%
        </div>
      </div>

      <!-- جدول الحالات الشاذة -->
      <div v-if="students.length > 0" class="card shadow-sm border-0">
        <div class="table-responsive">
          <table class="table table-bordered table-hover align-middle text-center mb-0">
            <thead class="table-dark">
              <tr>
                <th>سري</th>
                <!-- <th style="width: 25%">اسم الطالب</th> -->
                <th>نسبة النجاح</th>
                <th style="width: 40%">سبب التنبيه (المشكلة)</th>
                <th>إجراء</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="student in students" :key="student.id">
                <td class="fw-bold bg-light font-monospace">{{ student.SecretKey }}</td>
                <!-- <td class="text-end fw-bold">{{ student.Arabic_Name }}</td> -->
                
                <!-- نسبة النجاح -->
                <td>
                  <div class="progress position-relative" style="height: 25px;">
                    <div 
                      class="progress-bar" 
                      :class="getBarClass(student.calculated_percentage)"
                      role="progressbar" 
                      :style="{ width: student.calculated_percentage + '%' }"
                    ></div>
                    <span class="position-absolute w-100 text-center text-dark fw-bold" style="line-height: 25px;">
                      {{ student.calculated_percentage }}%
                    </span>
                  </div>
                </td>

                <!-- المشاكل المكتشفة -->
                <td class="text-start">
                  <div v-for="(issue, i) in student.audit_issues" :key="i" class="mb-1">
                    <div :class="'alert alert-' + issue.severity + ' py-1 px-2 mb-0 d-flex align-items-center small border-0'">
                      <i class="fas fa-exclamation-triangle ms-2"></i>
                      {{ issue.text }}
                    </div>
                  </div>
                </td>

                <!-- زر التصحيح -->
                <td>
                  <button @click="openEditModal(student)" class="btn btn-outline-dark btn-sm">
                    <i class="fas fa-edit ms-1"></i> فحص وتعديل
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Modal التعديل السريع -->
    <div v-if="showModal" class="modal-backdrop fade show"></div>
    <div v-if="showModal" class="modal fade show d-block" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-light">
            <h5 class="modal-title fw-bold">تعديل درجات الطالب: {{ selectedStudent.Arabic_Name }}</h5>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>
          <div class="modal-body">
            
            <div class="alert alert-info small">
              <i class="fas fa-info-circle ms-1"></i> قم بمراجعة الورقة وتعديل الدرجة الخاطئة ثم اضغط حفظ.
            </div>

           <div class="row g-3">
  <div class="col-md-4" v-for="sub in subjects" :key="sub.id">
    
    <!-- عنوان المادة -->
    <label class="form-label small fw-bold">
      {{ sub.name }} 
      <span class="text-muted">({{ sub.max }})</span>
    </label>

    <!-- حقل الدرجة -->
    <div class="position-relative">
      <input 
        type="number" 
        class="form-control text-center fw-bold" 
        v-model.number="selectedStudent[sub.code]"
        :class="getDegreeClass(selectedStudent[sub.code], sub)"
      >
      
      <!-- علامة صغيرة لتوضيح الرسوب -->
      <!-- <span v-if="isFailing(selectedStudent[sub.code], sub)" class="position-absolute top-50 start-0 translate-middle-y ms-2 text-danger small fw-bold">
        راسب
      </span> -->
    </div>

  </div>
</div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">إلغاء</button>
            <button type="button" class="btn btn-success" @click="saveChanges">
              <i class="fas fa-save ms-1"></i> حفظ التعديلات
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';
import Swal from 'sweetalert2';

export default {
  name: "GradeAudit",
  data() {
    return {
      loading: false,
      hasSearched: false,
      showModal: false,
      
      terms: [],
      groups: [],
      subjects: [], // نحتاجها في المودال
      
      students: [], // الطلاب الذين لديهم مشاكل
      stats: { total: 0 },
      
      form: { term: "", group: "" },
      selectedStudent: null, // الطالب المختار للتعديل
    };
  },
  mounted() {
    this.fetchInitData();
  },
  methods: {
    async fetchInitData() {
      try {
        const [termsRes, groupsRes] = await Promise.all([
          api.get("/getterms"),
          api.get("/getgroups")
        ]);
        this.terms = termsRes.data;
        this.groups = groupsRes.data;
      } catch (e) { console.error(e); }
    },

    async analyzeData() {
      if(!this.form.term || !this.form.group) {
          Swal.fire('تنبيه', 'اختر الفصل والمجموعة أولاً', 'warning');
          return;
      }

      this.loading = true;
      this.hasSearched = true;
      this.students = [];

      try {
        // جلب المواد لاستخدامها في المودال
        const subRes = await api.get("/getSubject/" + this.form.term['id']);
        this.subjects = subRes.data;

        // طلب التحليل من الباك اند
        const res = await api.post("/admin/audit-grades", this.form);
        
        this.students = res.data.flagged_students;
        this.stats.total = res.data.total_checked;

      } catch (e) {
        Swal.fire('خطأ', 'حدث خطأ أثناء التحليل', 'error');
      } finally {
        this.loading = false;
      }
    },

    getBarClass(percentage) {
        if(percentage >= 85) return 'bg-success';
        if(percentage >= 65) return 'bg-info';
        if(percentage >= 50) return 'bg-warning';
        return 'bg-danger';
    },

    openEditModal(student) {
        // نأخذ نسخة لعدم التعديل المباشر قبل الحفظ
        this.selectedStudent = JSON.parse(JSON.stringify(student));
        this.showModal = true;
    },
    
    closeModal() {
        this.showModal = false;
        this.selectedStudent = null;
    },

    async saveChanges() {
        try {
            // إرسال الطالب المعدل بالكامل للحفظ
            await api.post('/admin/update-student-grades', {
                id: this.selectedStudent.id,
                grades: this.selectedStudent // يحتوي على ar, en, ...
            });

            Swal.fire('تم', 'تم تصحيح الدرجات بنجاح', 'success');
            this.closeModal();
            this.analyzeData(); // إعادة الفحص للتأكد أن المشكلة حُلت

        } catch(e) {
            Swal.fire('خطأ', 'فشل الحفظ', 'error');
        }
    },
    getDegreeClass(degree, subject) {
        // 1. إذا كانت الدرجة أكبر من العظمى (خطأ فادح)
        if (degree > subject.max_degree) {
            return 'is-invalid border-danger bg-danger-subtle text-danger'; 
        }
        
        // 2. إذا كانت الدرجة أقل من الصغرى (راسب) - وهذا هو طلبك
        // نتأكد أنها ليست غياب (-1) أو قيمة فارغة
        if (degree >= 0 && degree < subject.main) {
            return 'border-danger text-danger bg-light'; // حدود ونص أحمر
        }

        // 3. درجة طبيعية
        return 'border-success text-dark';
    },

    // دالة مساعدة للتحقق من الرسوب (لإظهار كلمة "راسب")
    isFailing(degree, subject) {
        return degree >= 0 && degree < subject.main;
    }
  }
};
</script>

<style scoped>
.border-top-warning { border-top: 4px solid #ffc107; }
.pulse-animation {
  animation: pulse 2s infinite;
}
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.7; }
  100% { opacity: 1; }
}
.modal-backdrop { background-color: rgba(0,0,0,0.5); }

.bg-danger-subtle {
    background-color: #ffebe9 !important;
}

/* تنسيق حقل الراسب ليكون مميزاً */
input.text-danger {
    font-weight: 900 !important; /* خط سميك جداً للراسب */
    background-color: #fff5f5;
}
</style>